import * as React from "react";
import AppMainBodyRoutes from "../../routes/AppMainBodyRoutes";

export default function MainBody() {
  return <AppMainBodyRoutes />;
}
